import {Box, Stack, Typography, Button, useTheme, Grid} from '@mui/material';
import {LogInType} from 'app/types/Shared';
import {UserFilled} from '@carbon/icons-react';

type LogInProps = {
  selectLogInCallback: (arg0: LogInType) => void;
};

const LogIn = ({selectLogInCallback}: LogInProps) => {
  const theme = useTheme();

  return (
    <Stack width='100%' height='100%' spacing='30px'>
      <Box display='flex' flexDirection='column' width='100%' justifyContent='center' alignItems='center'>
        <Typography variant='h1' color={theme.palette.primary.main} pb={6}>
          Log into <b>ELEVATE</b>
        </Typography>
        <Grid container width='100%' direction='row'>
          <Grid item xs={2} />
          <Grid item xs={3} display='flex' alignItems='center' justifyContent='flex-end'>
            <Button
              variant='contained'
              sx={{
                bgcolor: theme.palette.primary.main,
                height: '144px',
                width: '100%',
                maxWidth: '225px',
                borderRadius: '6px',
                color: 'white',
                border: `1px solid ${theme.palette.primary.main}`,
              }}
              onClick={() => selectLogInCallback(LogInType.Internal)}
            >
              <Stack spacing={1} pt={2} width='100%' height='100%' justifyContent='flex-start' alignItems='center'>
                <UserFilled width='32px' height='32px' style={{color: 'inherit'}} />
                <Typography variant='h5' color='inherit'>
                  Takeda User
                </Typography>
                <Typography variant='h6' color='inherit'>
                  (Including FSP)
                </Typography>
              </Stack>
            </Button>
          </Grid>
          <Grid item xs={2} display='flex' alignItems='center' justifyContent='center'>
            <Typography color={theme.palette.primary.main}>or</Typography>
          </Grid>
          <Grid item xs={3} display='flex' alignItems='center' justifyContent='flex-start'>
            <Button
              variant='contained'
              sx={{
                bgcolor: theme.palette.primary.main,
                height: '144px',
                width: '100%',
                maxWidth: '225px',
                borderRadius: '6px',
                color: 'white',
                border: `1px solid ${theme.palette.primary.main}`,
              }}
              onClick={() => selectLogInCallback(LogInType.External)}
            >
              <Stack spacing={1} pt={2} width='100%' height='100%' justifyContent='flex-start' alignItems='center'>
                <UserFilled width='32px' height='32px' style={{color: 'inherit'}} />
                <Typography variant='h5' color='inherit'>
                  CRO User
                </Typography>
              </Stack>
            </Button>
          </Grid>
          <Grid item xs={2} />
        </Grid>
      </Box>
      <Grid container width='100%' direction='row'>
        <Grid item xs={2} />
        <Grid item xs={5} />
        <Grid item xs={3} />
        <Grid item xs={2} />
      </Grid>
    </Stack>
  );
};
export default LogIn;
